import { render } from "./AuthDeliveryTemplate.vue?vue&type=template&id=5a486ac4&scoped=true"
import script from "./AuthDeliveryTemplate.vue?vue&type=script&lang=js"
export * from "./AuthDeliveryTemplate.vue?vue&type=script&lang=js"

import "./AuthDeliveryTemplate.vue?vue&type=style&index=0&id=5a486ac4&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a486ac4"]])

export default __exports__